export default (to, from, next) => {
  if (localStorage.getItem("awqatiAccess_token")) {
    next();
  } else {
    next("/intro");
  }
};
